import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'mc0031',
    ecrans: ['00-2']
});
